import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Grid, Tab, Tabs, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import TabPanel from 'src/components/common/TabPanel';
import 'src/components/eTMF/Etmf.scss';
import { AppState, useAppSelector } from 'src/store';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { setDocumentKey } from 'src/store/preferences';
import { setRowDetail } from 'src/store/rowGridData';
import { TmfMenu, Translation } from 'src/types/Translation';
import AlertDialog from '../common/AlertDialog';
import { useTranslations } from '../common/hooks/useTranslations';
import { useUser } from '../common/hooks/useUser';
import { defaultTabKey, documentViewerKey, TabsData, TabsRoutesInfo } from './ETMFTabs';
/**
 * Tab props
 *
 * @param index Tab index.
 * @returns Tab props.
 */
function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

/**
 * Startup Component.
 *
 * @returns Startup component.
 */
export default function StartUp() {
  const [value, setValue] = React.useState(-1);
  const [prevClicked, setPrevClicked] = React.useState(0);
  const [moveTab, setMoveTab] = React.useState(true);
  const [selectedValue, setSelectedValue] = React.useState('');
  const [backButtonText, setBackButtonText] = React.useState('');
  const [backButtonClicked, setBackButtonClicked] = React.useState(false);
  const { roles } = useUser();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('md'));
  // const navMenuLocale: any = t('tmfMenu', { returnObjects: true });
  const startUpComponentLocale: any = t('startUp', { returnObjects: true });
  const tmfMenu = useTranslations({} as Translation, { returnObjects: true }, 'tmfMenu').tmfMenu;
  const documentKey: any = useAppSelector(state => state.preferences.documentKey);
  const dispatch = useDispatch();
  const MoveTab: any = useSelector((state: AppState) => state.MoveTab.MoveTabValue);

  React.useEffect(() => {
    if (MoveTab === true) {
      //  handleChange();
    }
  }, [MoveTab]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    //setValue(newValue);
    setPrevClicked(newValue);
    setConfirmExitPopupVal(dispatch, true);
    setRowDetail(dispatch, []);

    if (documentKey !== '' && documentKey !== null) {
      dispatch(
        setDocumentKey({
          document_id: 'cleared',
          study_id: null
        })
      );
    }
  };

  function getCurrentRoute(route: string) {
    if (route && route === 'landing') {
      setBackButtonText(startUpComponentLocale.backToLandingPager);
    } else if (route && route === 'recent_doc') {
      setBackButtonText(startUpComponentLocale.backToDocViewer);
    } else if (route && route === 'doc_upload') {
      setBackButtonText(startUpComponentLocale.backToDocUpload);
    } else if (route && route === 'binder_viewer') {
      setBackButtonText(startUpComponentLocale.backToBinderViewer);
    } else if (route && route === 'search') {
      setBackButtonText(startUpComponentLocale.backToSearch);
    } else if (route && route === 'task') {
      setBackButtonText(startUpComponentLocale.backToTask);
    } else {
      setBackButtonText('');
      setBackButtonClicked(false);
    }
  }

  const filtered = React.useMemo(() => {
    if (roles && roles.length) {
      let filtered = TabsData.filter(item => roles.includes(item.permissions) && item.enabled === true);
      filtered = filtered.map((item, index) => {
        item.index = index;
        return item;
      });
      if (documentKey?.document_id !== 'cleared') {
        const defaultTab = filtered.find(item => item.key === defaultTabKey);
        if (documentKey !== null && documentKey !== '') {
          const selectedTab: any = filtered.find(item => item.key === documentViewerKey);
          setSelectedValue(selectedTab);
          setValue(selectedTab?.index);
        } else if (defaultTab) {
          setValue(defaultTab.index);
        } else {
          setValue(0);
        }
      }
      return filtered;
    }
    return [];
  }, [roles, documentKey]);

  return (
    <>
      {' '}
      <AlertDialog setValue={setValue} prevClicked={prevClicked} />
      <div className="site-contact-page">
        {filtered && filtered.length > 0 && (
          <Grid container direction={isMediumScreen ? 'row' : 'column'}>
            <Grid item xs={2}>
              <Tabs
                className="lefttabs"
                orientation={isMediumScreen ? 'vertical' : 'horizontal'}
                value={value}
                onChange={handleChange}
                sx={{
                  '.MuiTabs-indicator': {
                    left: 0,
                    right: 'auto'
                  }
                }}
                TabIndicatorProps={{
                  style: { transition: 'none' }
                }}
              >
                {filtered.map((tabItem, i: number) => (
                  <Tab
                    label={tmfMenu[tabItem.key as keyof TmfMenu]}
                    {...a11yProps(0)}
                    sx={{ alignItems: 'start', textAlign: 'left' }}
                    key={`${tabItem.key}-${i}`}
                  />
                ))}
              </Tabs>
            </Grid>

            <Grid item xs={10}>
              {!backButtonText ||
                (backButtonText !== '' && (
                  <div style={{ margin: '0 0 -8px 16px' }}>
                    <Button
                      className="viewer-btn"
                      onClick={() => {
                        setBackButtonClicked(true);
                      }}
                      startIcon={<ArrowBackIcon />}
                    > 
                      {backButtonText}
                    </Button>
                  </div>
                ))}
              {filtered.map(tabItem => (
                <TabPanel value={value} index={tabItem.index} key={tabItem.key}>
                  {TabsRoutesInfo.includes(tabItem.key) ? (
                    <tabItem.component routeInfo={getCurrentRoute} onClicked={backButtonClicked}>
                      <ArrowBackIcon />
                    </tabItem.component>
                  ) : (
                    <tabItem.component index={tabItem.index}></tabItem.component>
                  )}
                </TabPanel>
              ))}
            </Grid>
          </Grid>
        )}
        {selectedValue === undefined && value === undefined && (
          <Grid container justifyContent={'center'} alignItems="top" style={{ minHeight: '100vh' }}>
            <h4>You don’t have required permission to view the document. Please contact administrator.</h4>
          </Grid>
        )}

        {filtered && filtered.length === 0 && (
          <Grid container justifyContent={'center'} alignItems="center" style={{ minHeight: '100vh' }}>
            <h4>You don’t have required permission to view the document. Please contact administrator.</h4>
          </Grid>
        )}
      </div>
    </>
  );
}
